// Textos editáveis da interface WikiPRIMATES em português brasileiro.
export const PT_BR = {
    footer: {
        description: 'Observação, ciência e comunidade.',
        about: 'Sobre o projeto',
        participate: 'Como participar',
        terms: 'Termos de Uso',
        security: 'Reportar problemas de segurança',
        privacy: 'Política de Privacidade',
        contact: 'Contato',
    },
    notFound: {
        code: '404',
        originalError: 'Erro 404',
        title: 'Página não encontrada',
        description: 'Parece que este caminho não existe.',
        backHome: 'Voltar para o início',
        imageAlt: 'Macaco triste sentado num galho',
    },
};
